//import { InMemoryWebStorage, WebStorageStateStore } from "oidc-client";

export const oidcSettings = {
  authority: "https://login.naked-energy.nl/oauth2/default",
  clientId: process.env.VUE_APP_OIDC_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OIDC_REDIRECT_URL,
  silentRedirectUri: process.env.VUE_APP_SILENT_REDIRECT_URL,
  responseType: "code",
  scope: process.env.VUE_APP_OIDC_SCOPES,
  automaticSilentRenew: true,
  automaticSilentSignin: false,
  post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI
  //userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() })
};
